export default __webpack_public_path__ + "static/media/Back.b7fe1d61.png";